module.exports = __webpack_public_path__ + "static/products-by-category-banner-cf54e649dbb9aa7668bd2fdb3fd26485.png";